var QuestionnaireService = (function () {
    function QuestionnaireService(apiService) {
        this.apiService = apiService;
    }
    //查询用户相应能力满意度
    QuestionnaireService.prototype.getUserQuestionnaireInfo = function (learningPathMetaId) {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v1/usersSatisficing/learningPathMetaId/' + learningPathMetaId
        });
    };
    //保存用户满意度信息
    QuestionnaireService.prototype.saveUserQuestionnaireInfo = function (data) {
        return this.apiService.ajax({
            'type': 'POST',
            'url': 'ddilearner/v1/usersSatisficing',
            'data': data
        }).toPromise();
    };
    //查询满意度页面显示信息
    QuestionnaireService.prototype.getQuestionnaireContent = function () {
        return this.apiService.ajax({
            'type': 'GET',
            'url': 'ddilearner/v1/usersSatisficingMetas'
        });
    };
    return QuestionnaireService;
}());
export { QuestionnaireService };



// WEBPACK FOOTER //
// ./src/app/app-questionnaire/questionnaireService.ts.pre-build-optimizer.js